<template>
    <section>
        <div>
            <div class="btn_group">
                <router-link to='/mypage/mychild/childreward' class="btn" :class="currentMode('myChildReward')">리워드내역</router-link> 
                <router-link to='/mypage/mychild/childList' class="btn" :class="currentMode('myChildList')">내 추천인들</router-link>              
            </div>    
            <router-view/>
        </div>
    </section>
</template>
<script>
export default {
    name:'myChild',
    methods:{
        currentMode(link)
        {
            if(this.$route.name === link)
            {
                return 'active'
            }else{
                return null
            }                    
        }         
    }
}
</script>
<style lang="scss" scoped>
.btn_group{
    padding-left:20px;    
    display:flex;
    justify-content:center;
    margin-bottom:10px;
    .btn:first-child{
        border-radius: .25rem;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right-width: 0;
    }
    .btn:last-child{
        border-radius: .25rem;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-width: 0;
    }
    .btn{
        padding-left: 1rem;
        padding-right: 1rem;
        padding-top: .5rem;
        padding-bottom: .5rem;
        transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;
        transition-duration: .2s;
        transition-timing-function: cubic-bezier(.4,0,.2,1);
        border: 1px solid #319795;      
        text-decoration:none;
        background-color: #e6fffa;
    }
    .btn:hover, .active{
        --transform-scale-x: 1.1;
        --transform-scale-y: 1.1;  
        color: #e6fffa; 
        background-color: #2c7a7b;
        font-weight:Bold;
        
    }
}
</style>